import { CurrencyIso } from './converters/convertCurrencyIso';

const getCurrencySymbol = (currencyIso: CurrencyIso): string => {
  let result: string = '';
  switch (currencyIso) {
    case CurrencyIso.HUF:
      result = 'Ft';
      break;
    case CurrencyIso.CHF:
      result = 'CHF';
      break;
    case CurrencyIso.EUR:
      result = '€';
      break;
    case CurrencyIso.GBP:
      result = '£';
      break;
    case CurrencyIso.JPY:
      result = '¥';
      break;
    case CurrencyIso.USD:
      result = '$';
      break;
    default:
      throw new Error('Unknown currency ISO: ' + currencyIso);
  }

  return result;
};

export default getCurrencySymbol;
